import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { getStatusBadge } from './tagStatusHelper';

/**
 * Formulario de creación y edición de incidencia
 */
const TagEditForm = ({
  selectedTag = null,
  formName = '',
  setFormName,
  formDescription = '',
  setFormDescription,
  formStatus = 1,
  setFormStatus,
  onSave,
  isDark = false
}) => {
  const previewStatusInfo = getStatusBadge(formStatus, isDark);

  return (
    <form onSubmit={onSave} id="form-incidencia">
      {/* Nombre y Estatus */}
      <div className="row g-2 mb-3">
        <div className="col-12 col-md-7">
          <label className="form-label small fw-semibold mb-1" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
            Nombre de la Incidencia <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control form-control-sm"
            style={{
              backgroundColor: isDark ? '#101c26' : '#ffffff',
              borderColor: isDark ? '#233142' : '#cbd5e1',
              color: isDark ? '#f9fafd' : '#0f172a'
            }}
            placeholder="Ej. Error de Facturación, Duda de Cobro..."
            maxLength={50}
            value={formName}
            onChange={e => setFormName(e.target.value)}
            required
          />
        </div>
        <div className="col-12 col-md-5">
          <label className="form-label small fw-semibold mb-1" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
            Estatus <span className="text-danger">*</span>
          </label>
          <select
            className="form-select form-select-sm"
            style={{
              backgroundColor: isDark ? '#101c26' : '#ffffff',
              borderColor: isDark ? '#233142' : '#cbd5e1',
              color: isDark ? '#f9fafd' : '#0f172a'
            }}
            value={formStatus}
            onChange={e => setFormStatus(Number(e.target.value))}
          >
            <option value={1}>Abierta</option>
            <option value={2}>En Progreso</option>
            {Number(selectedTag?.iEstadoIncidencia) === 3 && (
              <option value={3}>Resuelta</option>
            )}
          </select>
        </div>
      </div>

      {/* Notas y Descripción */}
      <div className="mb-3">
        <label className="form-label small fw-semibold mb-1" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
          Notas y Descripción para Desarrolladores <span className="text-muted fw-normal">(Opcional)</span>
        </label>
        <textarea
          className="form-control form-control-sm"
          rows={5}
          style={{
            backgroundColor: isDark ? '#101c26' : '#ffffff',
            borderColor: isDark ? '#233142' : '#cbd5e1',
            color: isDark ? '#f9fafd' : '#0f172a',
            fontFamily: 'inherit'
          }}
          placeholder="Escribe notas técnicas, pasos para reproducir o detalles de la incidencia..."
          value={formDescription}
          onChange={e => setFormDescription(e.target.value)}
        />
      </div>

      {/* Vista Previa del Badge */}
      <div className="mb-3">
        <div
          className="p-2.5 rounded-3 border d-flex align-items-center justify-content-between flex-wrap gap-2"
          style={{
            backgroundColor: isDark ? '#101c26' : '#f8fafc',
            borderColor: isDark ? '#233142' : '#e2e8f0'
          }}
        >
          <span className="small text-muted fw-medium" style={{ fontSize: '0.82rem' }}>Vista previa:</span>
          <div className="d-flex align-items-center gap-2">
            <span
              className="badge px-3 py-1.5 rounded-pill fw-semibold d-inline-flex align-items-center"
              style={{
                backgroundColor: isDark ? '#1e293b' : '#f1f5f9',
                color: isDark ? '#cbd5e1' : '#334155',
                border: `1px solid ${isDark ? '#334155' : '#cbd5e1'}`,
                fontSize: '0.84rem',
                gap: '6px',
                maxWidth: '240px',
                overflow: 'hidden'
              }}
            >
              <FontAwesomeIcon icon={faTag} className="me-1" style={{ fontSize: '0.72rem', opacity: 0.7 }} />
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {formName.trim() || 'Nombre de la Incidencia'}
              </span>
            </span>
            <span
              className="badge px-2.5 py-1 rounded-pill fw-semibold d-inline-flex align-items-center gap-1"
              style={{
                backgroundColor: previewStatusInfo.bg,
                color: previewStatusInfo.color,
                border: `1px solid ${previewStatusInfo.border}`,
                fontSize: '0.76rem'
              }}
            >
              <FontAwesomeIcon icon={previewStatusInfo.icon} className="me-1" style={{ fontSize: '0.68rem' }} />
              <span>{previewStatusInfo.label}</span>
            </span>
          </div>
        </div>
      </div>
    </form>
  );
};

export default TagEditForm;
